// @ts-check
import { generateMock } from '@anatine/zod-mock';
import { faker } from '@faker-js/faker';

import {
  ListTemplate,
} from '@/store/modules/bulkSend/models';

/** @typedef {import('@/store/modules/bulkSend/models/Templates').TListTemplate} TListTemplate */

/**
 * @param {object} [options]
 * @param {Partial<TListTemplate>} [options.properties]
 * @param {number} [options.seed]
 */
export function createListTemplate({ properties, seed } = {}) {
  const template = generateMock(ListTemplate, {
    stringMap: {
      fingerprint: () => faker.string.uuid(),
      title: () => [faker.hacker.verb(), faker.color.human()].join(' '),
    },
    seed,
  });

  return {
    ...template,
    created_at: faker.date.recent({ days: 28 }).getTime() / 1000,
    ...properties,
  };
}

/**
 * @param {number} count
 * @param {object} [options]
 * @param {Partial<TListTemplate[]>} [options.properties]
 * @param {number} [options.seed]
 */
export function createListTemplates(count, { properties, seed } = {}) {
  // eslint-disable-next-line no-param-reassign
  // const properties = options?.properties || [];
  return Array.from(Array(count), (_, index) =>
    createListTemplate({
      properties: properties ? properties[index] : undefined,
      seed: seed ? parseInt(`${seed}${index}`, 10) : undefined,
    }));
}
